import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import styled from "styled-components";
import { BsArrowRepeat } from "react-icons/bs";
import { FaStar, FaRegStar } from 'react-icons/fa';

const PartnerPerformance = () => {
    return (
        <Wrapper>
            <div className="container py-5">
                <div className="card border-0 shadow-sm p-4">
                    <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap">
                        <div>
                            <h4 className="text-dark mb-1 d-flex align-items-center">
                                Partner Performance
                            </h4>
                            <p className="text-muted mb-0">
                                View partner performance based on ticket sales and revenue
                            </p>
                        </div>
                    </div>

                    <div className="d-flex align-items-center flex-wrap gap-2 mb-3 filter-box">
                        {/* <input
                            type="text"
                            className="form-control"
                            placeholder="Search ID, Customer, Service"
                        /> */}
                        <select className="form-select">
                            <option>All Partners</option>
                            <option>Organization</option>
                            <option>Business</option>
                            <option>Tour and Travel Partners</option>
                        </select>
                        <select className="form-select">
                            <option>All Time</option>
                            <option>Today</option>
                            <option>Last Week </option>
                            <option>Last Month</option>
                            <option>Custom Date/Range</option>
                        </select>
                        <select className="form-select">
                            <option>All Salse</option>
                            <option>Online Sales</option>
                            <option>Counter Sales</option>
                        </select>
                        <select className="form-select">
                            <option>All Revenue</option>
                            <option>Online</option>
                            <option>Counter</option>
                        </select>
                        <select className="form-select">
                            <option>All Ratings</option>
                            <option>Newest</option>
                            <option>Older</option>
                        </select>
                        <button className="btn btn-outline-secondary d-flex align-items-center gap-1">
                            <BsArrowRepeat size={16} />
                            Clear Filters
                        </button>
                    </div>

                    <TableWrapper>
                        <table>
                            <thead>
                                <tr>
                                    <th>Partner Name</th>
                                    <th>Partner ID</th>
                                    <th>Category</th>
                                    <th>Ratings</th>
                                    <th>Online Sales</th>
                                    <th>Online Revenue</th>
                                    <th>Counter Sales</th>
                                    <th>Counter Revenue</th>
                                    <th>Total Sales</th>
                                    <th>Total Revenue</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Wanderlust Tours</td>
                                    <td>T3333</td>
                                    <td><span className="badge tour">Tour Operator</span></td>
                                    {/* <td><span className="stars">⭐⭐⭐⭐⭐ (4.1)</span></td> */}
                                     <td>
                                        <span className="stars" style={{ color: '#f5a623' }}>
                                            <FaStar />
                                            <FaStar />
                                            <FaStar />
                                            <FaStar />
                                            <FaRegStar />
                                            <small style={{ marginLeft: '5px' }}>(4.0)</small>
                                        </span>
                                    </td>
                                    <td>1</td>
                                    <td>$1500.00</td>
                                    <td>2</td>
                                    <td>$90.00</td>
                                    <td>3</td>
                                    <td className="bold">$1590.00</td>
                                </tr>
                                <tr>
                                    <td>EcoVentures Inc.</td>
                                    <td>B1111</td>
                                    <td><span className="badge business">Business</span></td>
                                    {/* <td><span className="stars">⭐⭐⭐⭐☆ (4.0)</span></td> */}
                                     <td>
                                        <span className="stars" style={{ color: '#f5a623' }}>
                                            <FaStar />
                                            <FaStar />
                                            <FaStar />
                                            <FaStar />
                                            <FaRegStar />
                                            <small style={{ marginLeft: '5px' }}>(4.0)</small>
                                        </span>
                                    </td>
                                    <td>6</td>
                                    <td>$340.00</td>
                                    <td>0</td>
                                    <td>$0.00</td>
                                    <td>6</td>
                                    <td className="bold">$340.00</td>
                                </tr>
                                <tr>
                                    <td>Global Trek Guides</td>
                                    <td>T8521</td>
                                    <td><span className="badge tour">Tour Operator</span></td>
                                    {/* <td><span className="stars">⭐⭐⭐½☆ (3.9)</span></td> */}
                                     <td>
                                        <span className="stars" style={{ color: '#f5a623' }}>
                                            <FaStar />
                                            <FaStar />
                                            <FaStar />
                                            <FaStar />
                                            <FaRegStar />
                                            <small style={{ marginLeft: '5px' }}>(4.0)</small>
                                        </span>
                                    </td>
                                    <td>1</td>
                                    <td>$250.00</td>
                                    <td>0</td>
                                    <td>$0.00</td>
                                    <td>1</td>
                                    <td className="bold">$250.00</td>
                                </tr>
                                <tr>
                                    <td>ThrillSeeker Adventures</td>
                                    <td>B8235</td>
                                    <td><span className="badge business">Business</span></td>
                                    {/* <td><span className="stars">⭐⭐⭐⭐⭐ (4.7)</span></td> */}
                                     <td>
                                        <span className="stars" style={{ color: '#f5a623' }}>
                                            <FaStar />
                                            <FaStar />
                                            <FaStar />
                                            <FaStar />
                                            <FaRegStar />
                                            <small style={{ marginLeft: '5px' }}>(4.0)</small>
                                        </span>
                                    </td>
                                    <td>2</td>
                                    <td>$135.50</td>
                                    <td>0</td>
                                    <td>$0.00</td>
                                    <td>2</td>
                                    <td className="bold">$135.50</td>
                                </tr>
                                <tr>
                                    <td>City Heritage Tours</td>
                                    <td>O7843</td>
                                    <td><span className="badge org">Organization</span></td>
                                    {/* <td><span className="stars">⭐⭐⭐⭐☆ (4.2)</span></td> */}
                                     <td>
                                        <span className="stars" style={{ color: '#f5a623' }}>
                                            <FaStar />
                                            <FaStar />
                                            <FaStar />
                                            <FaStar />
                                            <FaRegStar />
                                            <small style={{ marginLeft: '5px' }}>(4.0)</small>
                                        </span>
                                    </td>
                                    <td>2</td>
                                    <td>$45.00</td>
                                    <td>5</td>
                                    <td>$55.00</td>
                                    <td>7</td>
                                    <td className="bold">$100.00</td>
                                </tr>
                                <tr>
                                    <td>Aqua Fun Waterpark</td>
                                    <td>B9102</td>
                                    <td><span className="badge business">Business</span></td>
                                    {/* <td><span className="stars">⭐⭐⭐⭐⭐ (4.6)</span></td> */}
                                     <td>
                                        <span className="stars" style={{ color: '#f5a623' }}>
                                            <FaStar />
                                            <FaStar />
                                            <FaStar />
                                            <FaStar />
                                            <FaRegStar />
                                            <small style={{ marginLeft: '5px' }}>(4.0)</small>
                                        </span>
                                    </td>
                                    <td>3</td>
                                    <td>$55.00</td>
                                    <td>0</td>
                                    <td>$0.00</td>
                                    <td>3</td>
                                    <td className="bold">$55.00</td>
                                </tr>
                                <tr>
                                    <td>Community Arts Foundation</td>
                                    <td>O2222</td>
                                    <td><span className="badge org">Organization</span></td>
                                    {/* <td><span className="stars">⭐⭐⭐⭐½ (4.3)</span></td> */}
                                     <td>
                                        <span className="stars" style={{ color: '#f5a623' }}>
                                            <FaStar />
                                            <FaStar />
                                            <FaStar />
                                            <FaStar />
                                            <FaRegStar />
                                            <small style={{ marginLeft: '5px' }}>(4.0)</small>
                                        </span>
                                    </td>
                                    <td>0</td>
                                    <td>$0.00</td>
                                    <td>1</td>
                                    <td>$15.00</td>
                                    <td>1</td>
                                    <td className="bold">$15.00</td>
                                </tr>
                            </tbody>
                        </table>
                    </TableWrapper>
                </div>
            </div>
        </Wrapper>
    );
};

export default PartnerPerformance;

const Wrapper = styled.div`
  .filter-box input,
  .filter-box select {
    width: 169px !important;
  }
`;

const TableWrapper = styled.div`


  table {
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;
  }

  th,
  td {
    padding: 10px 12px;
    border: 1px solid #dee2e6;
    text-align: center;
    vertical-align: middle;
  }

  th {
    background-color: #f8f9fa;
    font-weight: 600;
  }

  .badge {
    display: inline-block;
    padding: 4px 10px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 500;
  }

  .badge.tour {
    background-color: rgba(255, 0, 150, 0.1);
    color: #d63384;
  }

  .badge.business {
    background-color: rgba(0, 123, 255, 0.1);
    color: #0d6efd;
  }

  .badge.org {
    background-color: rgba(0, 200, 150, 0.1);
    color: #20c997;
  }

  .stars {
    white-space: nowrap;
    font-size: 16px;
    color: #f4c150;
  }

  .bold {
    font-weight: bold;
    color: #007bff;
  }
`;
